import React from 'react';

const CreateScreen = React.lazy(() => import('./App/pages/Authentication/AbrirConta'));
const LoginScreen = React.lazy(() => import('./App/pages/Authentication/Login/index'));
const Recuperar = React.lazy(() => import('./App/pages/Authentication/Recuperar'));
const RecuperarConfirmar = React.lazy(() => import('./App/pages/Authentication/Recuperar-Confirmar'));

const route = [
	{ path: '/create-account', exact: true, private: false, name: process.env.REACT_APP_NOME + ' - Abrir uma conta', component: CreateScreen },
	{ path: '/login', exact: true, private: false, name: process.env.REACT_APP_NOME + ' - Login', component: LoginScreen },
	{ path: '/recuperar-senha', exact: true, private: false, name: process.env.REACT_APP_NOME + ' - Recuperar Senha', component: Recuperar },
	{ path: '/recuperar-senha/confirmar', exact: true, private: false, name: process.env.REACT_APP_NOME + ' - Recuperar Senha', component: RecuperarConfirmar }
];

export default route;
